import { createGlobalStyle } from 'styled-components'

// TODO: please remove me one react-switch is not used anymore
export const BooleanSwitchGlobalStyle = createGlobalStyle`
  .horizontal-boolean-filter {
    .mdc-switch {
      padding-top: 3px;

      .mdc-switch__thumb-underlay {
        top: -11px;
        height: 38px;
      }

      &.mdc-switch--checked {
        .mdc-switch__thumb-underlay {
          transform: translateX(10px);
        }
      }

      .mdc-switch__track {
        width: 27px;
        height: 13px;
      }

      .mdc-switch__thumb {
        width: 16px;
        height: 16px;
      }
    }
  }
`
